import { useAppContext } from "src/hooks/useAppContext";

/**
 * TODO: Refactor other places who need rootFolderId to use this method.
 */
export function useRootFolderId() {
  const context = useAppContext();
  return context?.currentSpace?.rootFolderId;
}
